import { useEffect, useRef } from 'react'

interface UseNotifyWhenEmptyIProps {
  count: number
  isError: boolean
  isLoading: boolean
  isOpen: boolean
  onEmpty?: () => void
}

/**
 * Fires onEmpty once when an open modal's settled list reaches zero (the
 * operator resolved the last stale incident, or the banner count was already
 * outdated at open), so the banner can re-check its count now rather than at
 * the next hourly tick. Once per empty transition; re-armed if items appear
 * again.
 */
export const useNotifyWhenEmpty = ({
  count,
  isError,
  isLoading,
  isOpen,
  onEmpty,
}: UseNotifyWhenEmptyIProps): void => {
  const hasNotifiedRef = useRef(false)
  useEffect(() => {
    if (!isOpen || isLoading || isError) return
    if (count > 0) {
      hasNotifiedRef.current = false
      return
    }
    if (!hasNotifiedRef.current) {
      hasNotifiedRef.current = true
      onEmpty?.()
    }
  }, [count, isError, isLoading, isOpen, onEmpty])
}
